var TotalSizeClass = (function () {
    function TotalSizeClass() {
    }
    return TotalSizeClass;
}());
//# sourceMappingURL=TotalSizeClass.js.map